import { createSelector } from 'reselect';
import UserListingColumns from '../../containers/UserListingColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.USER_LIST_PAGE.isLoading;
export const getData = TableDefinitions.USER_LIST_PAGE.getDataFunction();
export const getColumns = createSelector(getData, UserListingColumns);
